/**
 * PDP geo chips: country(s) + ONE primary parent region when known.
 * Mounts: [data-wmn-country-chips][data-product-handle]
 * Source: wmn-catalog-graph products[h].c + .rg
 *
 * Region chips are capped at 1; umbrellas (e.g. Africa) yield to more
 * specific members (West Africa).
 */
(function (window, document) {
  'use strict';

  /** Prefer these over their umbrella when both are present. */
  var SPECIFIC_OVER = {
    africa: [
      'west-africa',
      'east-africa',
      'southern-africa',
      'north-africa',
      'maghreb',
      'sahara-sahel'
    ],
    'latin-america': ['caribbean', 'andes'],
    'middle-east': ['maghreb'],
    mediterranean: ['maghreb', 'balkans']
  };

  function shopRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function geoHref(slug) {
    return shopRoot() + 'collections/all/' + encodeURIComponent(slug);
  }

  function titleCaseSlug(slug) {
    return String(slug || '')
      .split('-')
      .map(function (w) {
        if (!w) return w;
        if (w === 'usa') return 'USA';
        return w.charAt(0).toUpperCase() + w.slice(1);
      })
      .join(' ');
  }

  function displayCountry(graph, slug) {
    var node = graph && graph.countries && graph.countries[slug];
    if (node && node.n) return String(node.n);
    return titleCaseSlug(slug);
  }

  function displayRegion(graph, slug) {
    var node = graph && graph.regions && graph.regions[slug];
    if (node && node.n) return String(node.n);
    return titleCaseSlug(slug);
  }

  function collectCountries(graph, handle) {
    var out = [];
    var seen = {};
    if (!graph || !handle || !window.wmnCatalogGraph) return out;
    var resolved = window.wmnCatalogGraph.resolveProduct(handle);
    var slugs = (resolved && resolved.countries) || [];
    var i;
    for (i = 0; i < slugs.length; i++) {
      var slug = String(slugs[i] || '')
        .toLowerCase()
        .replace(/^\s+|\s+$/g, '');
      if (!slug || seen[slug]) continue;
      seen[slug] = true;
      out.push({ slug: slug, name: displayCountry(graph, slug), kind: 'country' });
    }
    return out;
  }

  function collectRegionsRaw(graph, handle) {
    var out = [];
    var seen = {};
    if (!graph || !handle || !window.wmnCatalogGraph) return out;
    var resolved = window.wmnCatalogGraph.resolveProduct(handle);
    var slugs = (resolved && resolved.regions) || [];
    var i;
    for (i = 0; i < slugs.length; i++) {
      var slug = String(slugs[i] || '')
        .toLowerCase()
        .replace(/^\s+|\s+$/g, '');
      if (!slug || seen[slug]) continue;
      seen[slug] = true;
      out.push({ slug: slug, name: displayRegion(graph, slug), kind: 'region' });
    }
    return out;
  }

  function collectRegions(graph, handle) {
    return pickPrimaryRegions(collectRegionsRaw(graph, handle));
  }

  /**
   * Keep graph order (title cues first) but drop umbrellas when a more
   * specific region is also present; return at most one chip.
   */
  function pickPrimaryRegions(items) {
    if (!items || !items.length) return [];
    var have = {};
    var i;
    for (i = 0; i < items.length; i++) {
      have[items[i].slug] = true;
    }
    var filtered = [];
    for (i = 0; i < items.length; i++) {
      var slug = items[i].slug;
      var specifics = SPECIFIC_OVER[slug];
      var skip = false;
      var j;
      if (specifics) {
        for (j = 0; j < specifics.length; j++) {
          if (have[specifics[j]]) {
            skip = true;
            break;
          }
        }
      }
      if (!skip) filtered.push(items[i]);
    }
    if (!filtered.length) filtered = items.slice(0, 1);
    return filtered.slice(0, 1);
  }

  function mergeUnique(a, b) {
    var seen = {};
    var out = [];
    var lists = [a || [], b || []];
    var li;
    var i;
    for (li = 0; li < lists.length; li++) {
      for (i = 0; i < lists[li].length; i++) {
        var row = lists[li][i];
        if (!row || !row.slug || seen[row.slug]) continue;
        seen[row.slug] = true;
        out.push(row);
      }
    }
    return out;
  }

  function collectFromDom(el) {
    var out = [];
    var seen = {};
    var links = el.querySelectorAll('a[data-wmn-geo], a[data-wmn-country], a.wmn-genres__chip');
    var i;
    for (i = 0; i < links.length; i++) {
      var a = links[i];
      var slug =
        a.getAttribute('data-wmn-geo') ||
        a.getAttribute('data-wmn-country') ||
        (a.getAttribute('href') || '').replace(/^.*\/collections\/all\//, '').split(/[?#]/)[0];
      slug = String(slug || '')
        .toLowerCase()
        .replace(/^\s+|\s+$/g, '');
      if (!slug || seen[slug]) continue;
      seen[slug] = true;
      out.push({
        slug: slug,
        name: (a.textContent || '').replace(/^\s+|\s+$/g, '') || titleCaseSlug(slug),
        kind: a.getAttribute('data-wmn-geo-kind') || 'country'
      });
    }
    return out;
  }

  function render(el, items) {
    var list = el.querySelector('.wmn-genres__list');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'wmn-genres__list';
      list.setAttribute('role', 'list');
      el.appendChild(list);
    }

    var hasCountry = false;
    var hasRegion = false;
    var i;
    for (i = 0; i < items.length; i++) {
      if (items[i].kind === 'region') hasRegion = true;
      else hasCountry = true;
    }
    var labelEl = el.querySelector('.wmn-genres__label');
    if (labelEl) {
      if (hasCountry && hasRegion) labelEl.textContent = 'Location';
      else if (hasRegion) labelEl.textContent = 'Region';
      else labelEl.textContent = 'Country';
    }
    el.setAttribute(
      'data-wmn-geo-kind',
      hasCountry && hasRegion ? 'both' : hasRegion ? 'region' : 'country'
    );

    if (!items.length) {
      list.innerHTML = '';
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      return;
    }

    var html = '';
    var max = el.classList.contains('wmn-genres--compact') ? 2 : 4;
    for (i = 0; i < items.length && i < max; i++) {
      var item = items[i];
      var label = String(item.name || item.slug).replace(/</g, '&lt;').replace(/"/g, '&quot;');
      var slug = encodeURIComponent(item.slug);
      var itemKind = item.kind || 'country';
      html +=
        '<li><a class="wmn-genres__chip" href="' +
        geoHref(item.slug) +
        '" title="Browse ' +
        label +
        '" data-wmn-geo="' +
        slug +
        '" data-wmn-geo-kind="' +
        itemKind +
        '">' +
        label +
        '</a></li>';
    }
    list.innerHTML = html;
    el.hidden = false;
    el.removeAttribute('aria-hidden');
  }

  function fillMount(el, graph) {
    var handle = el.getAttribute('data-product-handle') || el.getAttribute('data-handle');
    if (!handle) {
      el.hidden = true;
      return;
    }
    var fromDom = collectFromDom(el);
    var countries = collectCountries(graph, handle);
    var regions = collectRegions(graph, handle);

    // Stale CDN may lack products[h].c — keep Liquid country SSR.
    var i;
    if (!countries.length) {
      for (i = 0; i < fromDom.length; i++) {
        if (fromDom[i].kind === 'country') countries.push(fromDom[i]);
      }
      countries = countries.slice(0, 2);
    } else {
      countries = countries.slice(0, 2);
    }

    var domRegions = [];
    for (i = 0; i < fromDom.length; i++) {
      if (fromDom[i].kind === 'region') domRegions.push(fromDom[i]);
    }
    // Liquid SSR region wins when present — sessionStorage graph can lag tag fixes
    // (hard refresh does not clear sessionStorage; caused Belarus + Latin America).
    if (domRegions.length) {
      regions = pickPrimaryRegions(domRegions);
    } else if (!regions.length) {
      regions = [];
    }

    var items = mergeUnique(countries, regions);
    if (items.length) {
      render(el, items);
      return;
    }
    if (fromDom.length) {
      render(el, fromDom.slice(0, 3));
      return;
    }
    render(el, []);
  }

  function init() {
    var mounts = document.querySelectorAll('[data-wmn-country-chips]');
    if (!mounts.length) return;
    if (!window.wmnCatalogGraph || typeof window.wmnCatalogGraph.ensureLoaded !== 'function') {
      return;
    }
    window.wmnCatalogGraph
      .ensureLoaded()
      .then(function (graph) {
        var i;
        for (i = 0; i < mounts.length; i++) {
          fillMount(mounts[i], graph);
        }
      })
      .catch(function () {
        /* keep SSR chips if any */
      });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(init);

  document.addEventListener('instantclick:newpage', init);
  if (window.InstantClick && typeof InstantClick.on === 'function') {
    try {
      InstantClick.on('change', init);
    } catch (e) {
      /* ignore */
    }
  }

  window.wmnPdpCountryChips = { init: init };
})(window, document);
